import type { SVGProps } from 'react';

/** 목업의 AI 반짝이 아이콘. 색은 currentColor — 작은 별은 살짝 연하게. */
const SparkleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden
    {...props}
  >
    <path
      d="M6.07713 11.1777L7.18743 12.8125L8.82224 13.9228L7.18743 15.0331L6.07713 16.6679L4.96684 15.0331L3.33203 13.9228L4.96684 12.8125L6.07713 11.1777Z"
      fill="currentColor"
      opacity="0.7"
    />
    <path
      d="M11.9598 3.33398L13.2308 6.76886L16.6657 8.03987L13.2308 9.31089L11.9598 12.7458L10.6888 9.31089L7.25391 8.03987L10.6888 6.76886L11.9598 3.33398Z"
      fill="currentColor"
    />
  </svg>
);

export default SparkleIcon;
